import React, { FC } from 'react';
import cn from 'classnames';
import styles from './LandscapeAboutLandscapeAddTemplate.module.css';
import { Label } from '../../atoms';
import { LandscapeAboutLandscapeOrganism } from '../../organisms';
import { Container } from 'react-bootstrap';
import { EntityGalleryTileResponseDto } from '../../../store/landscapeAPI/galleryTile/dto/response/entity-gallery-tile-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface LandscapeAboutLandscapeAddTemplateProps {
  handleOnChange: (galleryTile: EntityGalleryTileResponseDto) => void;
  galleryTile: EntityGalleryTileResponseDto;
  callbackFn: (galleryTile: EntityGalleryTileResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  handleCancel: () => void;
}

const LandscapeAboutLandscapeAddTemplate: FC<
  LandscapeAboutLandscapeAddTemplateProps
> = ({
  handleOnChange,
  galleryTile,
  callbackFn,
  handleImageOnChange,
  handleCancel,
}) => {
  return (
    <>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Create New Gallery Tile" size="lg" />
        </div>
        <LandscapeAboutLandscapeOrganism
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
          galleryTile={galleryTile}
          handleImageOnChange={handleImageOnChange}
          handleCancel={handleCancel}
        />
      </Container>
    </>
  );
};

export default LandscapeAboutLandscapeAddTemplate;
